export default __webpack_public_path__ + "static/media/openx-icon.63eb2884.svg";